import {
  isBackdrop
} from "./IXXFVVA2.js";
import {
  walkTreeOutside
} from "./VRCYQ6JX.js";
import {
  setAttribute
} from "./FW6QFGFT.js";

// src/dialog/utils/disable-accessibility-tree-outside.ts
function hideElementFromAccessibilityTree(element) {
  return setAttribute(element, "aria-hidden", "true");
}
function disableAccessibilityTreeOutside(id, elements) {
  const cleanups = [];
  const ids = elements.map((el) => el == null ? void 0 : el.id);
  walkTreeOutside(id, elements, (element) => {
    if (isBackdrop(element, ...ids))
      return;
    cleanups.unshift(hideElementFromAccessibilityTree(element));
  });
  const restoreAccessibilityTree = () => {
    cleanups.forEach((fn) => fn());
  };
  return restoreAccessibilityTree;
}

export {
  hideElementFromAccessibilityTree,
  disableAccessibilityTreeOutside
};
